var Reverb = window.Reverb || {};

Reverb.Shop = (function () {
  function setInitialPaypalStatus() {
    if ($('#payment_method_select').length !== 0 &&
       $('#payment_method_select').is(':visible') &&
       !$('#user_accepted_payment_methods_paypal').is(':checked')) {
      togglePaypalState();
    }
  }

  function bindPaypalCheckBoxHandler() {
    $('#user_accepted_payment_methods_paypal').change(function () {
      togglePaypalState();
    });
  }

  function togglePaypalState() {
    var paypal_email = $('input#product_paypal_email, input#user_paypal_email');
    paypal_email.toggleClass('required');
    paypal_email.removeClass('ui-state-error');
    paypal_email.prop('required', !paypal_email.prop('required'));
  }

  function init() {
    setInitialPaypalStatus();
    bindPaypalCheckBoxHandler();
  }

  return {
    init: init
  };
})();

$(function () {
  Reverb.Shop.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/shop.js